import { default as $ } from 'jquery'

$(document).on('click', '.flash .close-button', (event) => {
  let flashContainer = $(event.target).parents('.flash');

  flashContainer.remove()
});
